export function VersionInfo() {
  const version = import.meta.env.VITE_APP_VERSION || '0.0.0';
  return (
    <div className="text-small text-slate-500 w-full text-center my-3">
      {' '}
      v{version}
    </div>
  );
}

